import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78c42f2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-top":"110px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, { style: {"-webkit-box-shadow":"none","box-shadow":"none","border-bottom":"var(--ion-color-medium-tint)","border-bottom-style":"solid","border-bottom-width":"1px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { mode: "md" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_title, { style: {"font-family":"'San Francisco', sans-serif","font-weight":"700","text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode("Edit Device")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, {
      class: "ion-no-padding",
      style: {"--background":"white"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_list, { lines: "none" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  label: "Device Name",
                  style: {"font-family":"'San Francisco', sans-serif","font-weight":"700","text-align":"right"},
                  modelValue: _ctx.deviceRef.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deviceRef.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Device Type")
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_label, { style: {"font-family":"'San Francisco', sans-serif","font-weight":"700","text-align":"right"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.deviceRef.type.toUpperCase()), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.deviceRef.active,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deviceRef.active) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Push Notifications")
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ion_chip, {
                  style: {"margin-left":"10px"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.basicAlert('Notice', '', _ctx.noticeText)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("?")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_1,
        _createVNode(_component_ion_grid, {
          mode: "ios",
          class: "ldx-bottom-fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","border-radius":"10px","--border-width":"2px","--border-style":"solid","--border-color":"var(--ion-color-danger)"},
                      color: "danger",
                      onClick: _ctx.cancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      style: {"width":"-webkit-fill-available","border-radius":"10px","--border-width":"2px","--border-style":"solid","--border-color":"var(--ion-color-primary)"},
                      color: "primary",
                      onClick: _ctx.save
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}